document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('card-selector-root');
  if (!root) return;

  var categoriesNode = document.getElementById('card-selector-categories');
  var cardsNode = document.getElementById('card-selector-cards');

  var categories = categoriesNode ? JSON.parse(categoriesNode.textContent) : [];
  var cards = cardsNode ? JSON.parse(cardsNode.textContent) : [];

  var state = {
    configHandle: root.getAttribute('data-selector-config-handle') || '',
    pageUrl: root.getAttribute('data-selector-page-url') || '',
    supportProductId: root.getAttribute('data-support-product-id') || '',
    supportProductHandle: root.getAttribute('data-support-product-handle') || '',
    supportProductTitle: root.getAttribute('data-support-product-title') || '',
    supportPrice: Number(root.getAttribute('data-support-price') || 0),
    packProductId: root.getAttribute('data-pack-product-id') || '',
    createProductId: root.getAttribute('data-create-product-id') || '',
    packProductHandle: root.getAttribute('data-pack-product-handle') || '',
    createProductHandle: root.getAttribute('data-create-product-handle') || '',
    packSize: Number(root.getAttribute('data-pack-size') || 5),
    packPrice: Number(root.getAttribute('data-pack-price') || 0),
    createPrice: Number(root.getAttribute('data-create-price') || 0),
    shopRootUrl: root.getAttribute('data-shop-root-url') || '/',
    cartUrl: root.getAttribute('data-cart-url') || '/cart',
    withSupport: false,
    categories: categories,
    cards: cards,
    quantities: {},
    customCreations: []
  };

  var placeholder = root.querySelector('.card-selector-placeholder');
  if (!placeholder) return;

  var urlParams = new URLSearchParams(window.location.search);
  state.withSupport = urlParams.get('with-support') === '1';

  loadProductData()
    .then(function () {
      return loadExistingSelectionFromCart();
    })
    .then(function () {
      render();
    });

  function loadProductData() {
    var requests = [];

    if (state.supportProductHandle) {
      requests.push(
        fetchProductByHandle(state.supportProductHandle).then(function (product) {
          if (product) {
            state.supportPrice = Number(product.price || 0);
            state.supportProductTitle = product.title || state.supportProductTitle || '';
            if (product.variants && product.variants.length) {
              state.supportProductId = String(product.variants[0].id);
            }
          }
        })
      );
    }

    if (state.packProductHandle) {
      requests.push(
        fetchProductByHandle(state.packProductHandle).then(function (product) {
          if (product) {
            state.packPrice = Number(product.price || 0);
            if (product.variants && product.variants.length) {
              state.packProductId = String(product.variants[0].id);
            }
          }
        })
      );
    }

    if (state.createProductHandle) {
      requests.push(
        fetchProductByHandle(state.createProductHandle).then(function (product) {
          if (product) {
            state.createPrice = Number(product.price || 0);
            if (product.variants && product.variants.length) {
              state.createProductId = String(product.variants[0].id);
            }
          }
        })
      );
    }

    return Promise.all(requests).catch(function (error) {
      console.error('Erreur chargement produits', error);
    });
  }

  function fetchProductByHandle(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Produit introuvable pour le handle : ' + handle);
        }
        return response.json();
      });
  }

  function loadExistingSelectionFromCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Impossible de lire le panier.');
        }
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;

        resetLoadedSelection();

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var props = item.properties || {};

          if (props['Configuration sélecteur'] !== state.configHandle) continue;

          if (props['Détail cartes']) {
            hydrateCardsFromText(props['Détail cartes']);
          }

          if (props['Détail créations']) {
            hydrateCreationsFromText(props['Détail créations']);
          }
        }
      })
      .catch(function (error) {
        console.error('Erreur chargement sélection existante', error);
      });
  }

  function resetLoadedSelection() {
    state.quantities = {};
    state.customCreations = [];
  }

  function hydrateCardsFromText(text) {
    if (!text) return;

    var parts = String(text).split(' | ');
    for (var i = 0; i < parts.length; i++) {
      var line = parts[i];
      var match = line.match(/^(.*)\sx(\d+)$/);
      if (!match) continue;

      var cardName = match[1];
      var quantity = parseInt(match[2], 10);
      if (!quantity) continue;

      var card = findCardByName(cardName);
      if (!card || !card.code) continue;

      state.quantities[card.code] = quantity;
    }
  }

  function hydrateCreationsFromText(text) {
    if (!text) return;

    var parts = String(text).split(' | ');
    for (var i = 0; i < parts.length; i++) {
      var line = parts[i];
      var match = line.match(/^Création\s\d+\s:\s(.*)$/);
      if (!match) continue;

      var creationText = match[1];
      if (!creationText) continue;

      state.customCreations.push({
        id: 'creation_loaded_' + i + '_' + Math.floor(Math.random() * 10000),
        text: creationText
      });
    }
  }

  function findCardByName(name) {
    var target = String(name || '').trim().toLowerCase();

    for (var i = 0; i < state.cards.length; i++) {
      if (String(state.cards[i].name || '').trim().toLowerCase() === target) {
        return state.cards[i];
      }
    }

    return null;
  }

  function render() {
    var html = '';
    html += '<div class="cs-topbar">';
    html += '  <div class="cs-search">';
    html += '    <input type="search" id="cs-search-input" class="cs-search__input" placeholder="Rechercher une carte">';
    html += '  </div>';
    html += '</div>';

    html += '<div id="cs-search-results" class="cs-search-results" hidden></div>';

    html += '<div class="cs-accordion-list">';
    for (var i = 0; i < state.categories.length; i++) {
      var category = state.categories[i];
      var categoryCards = getCardsByCategory(category.slug);
      var selectedCount = getSelectedCountByCategory(category.slug);

      html += '<details class="cs-accordion" data-category="' + escapeHtml(category.slug) + '">';
      html += '  <summary class="cs-accordion__summary">';
      html += '    <span class="cs-accordion__title-wrap">';
      html += '      <span>' + escapeHtml(category.name) + '</span>';
      html += '      <span class="cs-accordion__count" data-category-count="' + escapeHtml(category.slug) + '">' + selectedCount + '</span>';
      html += '    </span>';
      html += '    <span class="cs-accordion__icon" aria-hidden="true">+</span>';
      html += '  </summary>';
      html += '  <div class="cs-accordion__content">';
      html += '    <div class="cs-card-grid">';

      for (var j = 0; j < categoryCards.length; j++) {
        html += renderCard(categoryCards[j]);
      }

      html += '    </div>';
      html += '  </div>';
      html += '</details>';
    }
    html += '</div>';

    html += renderCreationBlock();
    html += '<div id="cs-sticky-summary" class="cs-sticky-summary"></div>';

    placeholder.innerHTML = html;

    bindSearch();
    bindCardSelection();
    bindQuantityButtons();
    bindCreationActions();
    updateSummary();
  }

  function renderCreationBlock() {
    var html = '';
    html += '<section class="cs-creation">';
    html += '  <div class="cs-creation__header">';
    html += '    <h2 class="cs-creation__title">Créer une carte sur mesure</h2>';
    html += '    <p class="cs-creation__text">Si la carte n’existe pas, décrivez-la ici. Chaque demande ajoutée sera traitée comme une création sur mesure.</p>';
    html += '  </div>';
    html += '  <div class="cs-creation__form">';
    html += '    <textarea id="cs-creation-input" class="cs-creation__textarea" rows="4" placeholder="Exemple : Mettre les lunettes dans l’étui, avec un pictogramme simple et lisible."></textarea>';
    html += '    <button type="button" id="cs-creation-add" class="cs-creation__add">Ajouter cette création</button>';
    html += '  </div>';
    html += '  <div id="cs-creation-list" class="cs-creation__list">';
    html += renderCreationList();
    html += '  </div>';
    html += '</section>';
    return html;
  }

  function renderCreationList() {
    if (!state.customCreations.length) {
      return '<div class="cs-creation__empty">Aucune création ajoutée pour le moment.</div>';
    }

    var html = '';
    for (var i = 0; i < state.customCreations.length; i++) {
      var item = state.customCreations[i];
      html += '<article class="cs-creation-item" data-creation-id="' + escapeHtml(item.id) + '">';
      html += '  <div class="cs-creation-item__content">';
      html += '    <div class="cs-creation-item__label">Création ' + (i + 1) + '</div>';
      html += '    <div class="cs-creation-item__text">' + escapeHtml(item.text) + '</div>';
      html += '  </div>';
      html += '  <div class="cs-creation-item__actions">';
      html += '    <button type="button" class="cs-creation-item__btn" data-action="edit" data-creation-id="' + escapeHtml(item.id) + '">Modifier</button>';
      html += '    <button type="button" class="cs-creation-item__btn cs-creation-item__btn--danger" data-action="delete" data-creation-id="' + escapeHtml(item.id) + '">Supprimer</button>';
      html += '  </div>';
      html += '</article>';
    }
    return html;
  }

  function renderSearchResults(matches) {
    var searchResults = document.getElementById('cs-search-results');
    var accordionList = placeholder.querySelector('.cs-accordion-list');

    if (!matches.length) {
      accordionList.hidden = true;
      searchResults.hidden = false;
      searchResults.innerHTML = '<div class="cs-empty">Aucune carte trouvée.</div>';
      bindQuantityButtons();
      return;
    }

    var html = '<div class="cs-results-title">Résultats</div>';
    html += '<div class="cs-card-grid">';
    for (var i = 0; i < matches.length; i++) {
      html += renderCard(matches[i]);
    }
    html += '</div>';

    accordionList.hidden = true;
    searchResults.hidden = false;
    searchResults.innerHTML = html;

    bindCardSelection();
    bindQuantityButtons();
  }

  function renderCard(card) {
    var qty = Number(state.quantities[card.code] || 0);
    var selectedClass = qty > 0 ? ' is-selected' : '';
    var html = '';

    html += '<article class="cs-card" data-card-code="' + escapeHtml(card.code) + '">';
    html += '  <button type="button" class="cs-card__select' + selectedClass + '" data-card-code="' + escapeHtml(card.code) + '" aria-label="' + escapeHtml(card.name) + '">';
    html += '    <div class="cs-card__media">';
    if (card.image) {
      html += '      <img src="' + escapeHtml(card.image) + '" alt="' + escapeHtml(card.name) + '" loading="lazy">';
    } else {
      html += '      <div class="cs-card__media-placeholder"></div>';
    }
    html += '    </div>';
    html += '    <div class="cs-card__body">';
    html += '      <h3 class="cs-card__title">' + escapeHtml(card.name) + '</h3>';
    html += '    </div>';
    html += '  </button>';
    html += '  <div class="cs-qty' + (qty > 0 ? '' : ' is-hidden') + '" data-card-code="' + escapeHtml(card.code) + '">';
    html += '    <button type="button" class="cs-qty__btn" data-action="decrease" data-card-code="' + escapeHtml(card.code) + '" aria-label="Retirer une carte">-</button>';
    html += '    <span class="cs-qty__value" data-card-code="' + escapeHtml(card.code) + '">' + qty + '</span>';
    html += '    <button type="button" class="cs-qty__btn" data-action="increase" data-card-code="' + escapeHtml(card.code) + '" aria-label="Ajouter une carte">+</button>';
    html += '  </div>';
    html += '</article>';

    return html;
  }

  function bindSearch() {
    var searchInput = document.getElementById('cs-search-input');
    var searchResults = document.getElementById('cs-search-results');
    var accordionList = placeholder.querySelector('.cs-accordion-list');

    if (!searchInput) return;

    searchInput.addEventListener('input', function () {
      var term = searchInput.value.replace(/^\s+|\s+$/g, '').toLowerCase();

      if (!term) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
        accordionList.hidden = false;
        bindCardSelection();
        bindQuantityButtons();
        return;
      }

      var matches = [];
      for (var i = 0; i < state.cards.length; i++) {
        var name = (state.cards[i].name || '').toLowerCase();
        if (name.indexOf(term) !== -1) {
          matches.push(state.cards[i]);
        }
      }

      renderSearchResults(matches);
    });
  }

  function bindCardSelection() {
    var buttons = placeholder.querySelectorAll('.cs-card__select');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function () {
        var code = this.getAttribute('data-card-code');
        var current = Number(state.quantities[code] || 0);

        if (current === 0) {
          state.quantities[code] = 1;
          syncCardState(code);
          updateSummary();
        }
      });
    }
  }

  function bindQuantityButtons() {
    var buttons = placeholder.querySelectorAll('.cs-qty__btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function () {
        var code = this.getAttribute('data-card-code');
        var action = this.getAttribute('data-action');
        var current = Number(state.quantities[code] || 0);

        if (action === 'increase') {
          state.quantities[code] = current + 1;
        }

        if (action === 'decrease') {
          state.quantities[code] = Math.max(0, current - 1);
        }

        syncCardState(code);
        updateSummary();
      });
    }
  }

  function bindCreationActions() {
    var addBtn = document.getElementById('cs-creation-add');
    var input = document.getElementById('cs-creation-input');
    var list = document.getElementById('cs-creation-list');

    if (addBtn && input) {
      addBtn.addEventListener('click', function () {
        var text = input.value.replace(/^\s+|\s+$/g, '');
        if (!text) return;

        state.customCreations.push({
          id: 'creation_' + Date.now() + '_' + Math.floor(Math.random() * 10000),
          text: text
        });

        input.value = '';
        refreshCreationList();
        updateSummary();
      });
    }

    if (list) {
      list.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.getAttribute) return;

        var action = target.getAttribute('data-action');
        var id = target.getAttribute('data-creation-id');
        if (!action || !id) return;

        if (action === 'delete') {
          state.customCreations = state.customCreations.filter(function (item) {
            return item.id !== id;
          });
          refreshCreationList();
          updateSummary();
        }

        if (action === 'edit') {
          var currentItem = null;
          for (var i = 0; i < state.customCreations.length; i++) {
            if (state.customCreations[i].id === id) {
              currentItem = state.customCreations[i];
              break;
            }
          }

          if (!currentItem) return;

          var nextText = window.prompt('Modifier cette création', currentItem.text);
          if (nextText === null) return;

          nextText = nextText.replace(/^\s+|\s+$/g, '');
          if (!nextText) return;

          currentItem.text = nextText;
          refreshCreationList();
          updateSummary();
        }
      });
    }
  }

  function refreshCreationList() {
    var list = document.getElementById('cs-creation-list');
    if (!list) return;
    list.innerHTML = renderCreationList();
  }

  function syncCardState(code) {
    var qty = Number(state.quantities[code] || 0);

    var values = placeholder.querySelectorAll('.cs-qty__value[data-card-code="' + code.replace(/"/g, '\\"') + '"]');
    for (var i = 0; i < values.length; i++) {
      values[i].textContent = qty;
    }

    var cardButtons = placeholder.querySelectorAll('.cs-card__select[data-card-code="' + code.replace(/"/g, '\\"') + '"]');
    for (var j = 0; j < cardButtons.length; j++) {
      if (qty > 0) {
        cardButtons[j].classList.add('is-selected');
      } else {
        cardButtons[j].classList.remove('is-selected');
      }
    }

    var qtyBlocks = placeholder.querySelectorAll('.cs-qty[data-card-code="' + code.replace(/"/g, '\\"') + '"]');
    for (var k = 0; k < qtyBlocks.length; k++) {
      if (qty > 0) {
        qtyBlocks[k].classList.remove('is-hidden');
      } else {
        qtyBlocks[k].classList.add('is-hidden');
      }
    }

    updateCategoryCounts();
  }

  function updateCategoryCounts() {
    for (var i = 0; i < state.categories.length; i++) {
      var slug = state.categories[i].slug;
      var count = getSelectedCountByCategory(slug);
      var badges = placeholder.querySelectorAll('[data-category-count="' + slug.replace(/"/g, '\\"') + '"]');

      for (var j = 0; j < badges.length; j++) {
        badges[j].textContent = count;
      }
    }
  }

  function updateSummary() {
    var summary = document.getElementById('cs-sticky-summary');
    if (!summary) return;

    var totalCards = 0;
    var selectedCards = [];

    for (var i = 0; i < state.cards.length; i++) {
      var card = state.cards[i];
      var qty = Number(state.quantities[card.code] || 0);

      if (qty > 0) {
        totalCards += qty;
        selectedCards.push({
          code: card.code,
          name: card.name,
          quantity: qty
        });
      }
    }

    var packCount = totalCards > 0 ? Math.ceil(totalCards / state.packSize) : 0;
    var creationCount = Array.isArray(state.customCreations) ? state.customCreations.length : 0;

    var supportTotalCents = state.withSupport ? state.supportPrice : 0;
    var packsTotalCents = packCount * state.packPrice;
    var creationsTotalCents = creationCount * state.createPrice;
    var totalPriceCents = supportTotalCents + packsTotalCents + creationsTotalCents;

    var totalPrice = formatMoney(totalPriceCents);
    var supportPrice = formatMoney(supportTotalCents);
    var packsPrice = formatMoney(packsTotalCents);
    var creationsPrice = formatMoney(creationsTotalCents);
    var supportLabel = state.supportProductTitle || 'Support';

    summary.innerHTML =
      '<div class="cs-sticky-summary__inner">' +
        '<div class="cs-sticky-summary__meta">' +
          (state.withSupport
            ? '<div class="cs-sticky-summary__line"><strong>1</strong> ' + escapeHtml(supportLabel) + ' - ' + supportPrice + '</div>'
            : '') +
          '<div class="cs-sticky-summary__line"><strong>' + totalCards + '</strong> carte' + (totalCards > 1 ? 's' : '') + ' sélectionnée' + (totalCards > 1 ? 's' : '') + '</div>' +
          '<div class="cs-sticky-summary__line"><strong>' + packCount + '</strong> pack' + (packCount > 1 ? 's' : '') + ' - ' + packsPrice + '</div>' +
          '<div class="cs-sticky-summary__line"><strong>' + creationCount + '</strong> création' + (creationCount > 1 ? 's' : '') + ' - ' + creationsPrice + '</div>' +
        '</div>' +
        '<div class="cs-sticky-summary__actions">' +
          '<div class="cs-sticky-summary__price">' + totalPrice + '</div>' +
          '<button type="button" id="cs-add-to-cart" class="cs-sticky-summary__button">Ajouter au panier</button>' +
        '</div>' +
      '</div>';

    bindAddToCartButton({
      totalCards: totalCards,
      packCount: packCount,
      creationCount: creationCount,
      selectedCards: selectedCards,
      creations: state.customCreations.slice()
    });

    updateCategoryCounts();
  }

  function bindAddToCartButton(payload) {
    var button = document.getElementById('cs-add-to-cart');
    if (!button) return;

    button.addEventListener('click', function () {
      var selectedCardsText = buildSelectedCardsText(payload.selectedCards);
      var creationsText = buildCreationsText(payload.creations);
      var selectorEditUrl = generateSelectorEditUrl();

      var supportItem = null;
      var packItem = null;
      var creationItem = null;

      if (state.withSupport && !state.supportProductId) {
        window.alert('Impossible de charger le produit support.');
        return;
      }

      if ((payload.packCount > 0 && !state.packProductId) || (payload.creationCount > 0 && !state.createProductId)) {
        window.alert('Impossible de charger les variantes produit nécessaires.');
        return;
      }

      if (!state.withSupport && !payload.packCount && !payload.creationCount) {
        var confirmEmpty = window.confirm('Vous êtes sur le point de continuer sans ajouter de cartes ni de création. Voulez-vous poursuivre ?');
        if (!confirmEmpty) return;
        return;
      }

      if (state.withSupport) {
        supportItem = {
          id: parseInt(state.supportProductId, 10),
          quantity: 1,
          properties: {
            'Configuration sélecteur': state.configHandle,
            'Mode': 'Avec support',
            'URL configurateur': selectorEditUrl
          }
        };
      }

      if (payload.packCount === 0 && payload.creationCount === 0 && state.withSupport) {
        var confirmSupportOnly = window.confirm('Vous êtes sur le point de commander le support seul, sans cartes ni création. Voulez-vous poursuivre ?');
        if (!confirmSupportOnly) return;
      }

      if (payload.packCount > 0) {
        packItem = {
          id: parseInt(state.packProductId, 10),
          quantity: payload.packCount,
          properties: {
            'Configuration sélecteur': state.configHandle,
            'Mode': state.withSupport ? 'Avec support' : 'Sans support',
            'URL configurateur': selectorEditUrl,
            'Total cartes': String(payload.totalCards),
            'Taille pack': String(state.packSize),
            'Détail cartes': selectedCardsText
          }
        };
      }

      if (payload.creationCount > 0) {
        creationItem = {
          id: parseInt(state.createProductId, 10),
          quantity: payload.creationCount,
          properties: {
            'Configuration sélecteur': state.configHandle,
            'Mode': state.withSupport ? 'Avec support' : 'Sans support',
            'URL configurateur': selectorEditUrl,
            'Total créations': String(payload.creationCount),
            'Détail créations': creationsText
          }
        };
      }

      button.disabled = true;
      button.textContent = 'Ajout en cours...';

      removeExistingSelectorItems()
        .then(function () {
          return addItemsSequentially(supportItem, packItem, creationItem);
        })
        .then(function () {
          return refreshCartUI();
        })
        .then(function () {
          showCartFeedback();
        })
        .catch(function (error) {
          console.error('Erreur ajout panier détaillée', error);
          window.alert(error && error.message ? error.message : 'Une erreur est survenue lors de l’ajout au panier.');
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = 'Ajouter au panier';
        });
    });
  }

  function generateSelectorEditUrl() {
    var baseUrl = state.pageUrl || window.location.pathname || '/';
    var absoluteUrl = new URL(baseUrl, window.location.origin);

    absoluteUrl.searchParams.delete('with-support');

    if (state.withSupport) {
      absoluteUrl.searchParams.set('with-support', '1');
    }

    return absoluteUrl.pathname + absoluteUrl.search;
  }

  function removeExistingSelectorItems() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Impossible de lire le panier.');
        }
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;

        var updates = {};
        var hasUpdates = false;

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var props = item.properties || {};
          if (props['Configuration sélecteur'] === state.configHandle) {
            updates[String(item.key)] = 0;
            hasUpdates = true;
          }
        }

        if (!hasUpdates) return;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (response) {
            return response.text().then(function (text) {
              if (!response.ok) {
                throw new Error(text || 'Erreur lors de la suppression de l’ancienne configuration');
              }

              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            });
          })
          .then(function () {
            return refreshCartUI();
          });
      });
  }

  function addItemsSequentially(supportItem, packItem, creationItem) {
    var sequence = Promise.resolve();

    if (supportItem) {
      sequence = sequence.then(function () {
        return addSingleItem(supportItem);
      });
    }

    if (packItem) {
      sequence = sequence.then(function () {
        return addSingleItem(packItem);
      });
    }

    if (creationItem) {
      sequence = sequence.then(function () {
        return addSingleItem(creationItem);
      });
    }

    return sequence;
  }

  function getThemeCartController() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addSingleItem(item) {
    var cartController = getThemeCartController();
    var config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      }
    };

    var formData = new FormData();
    formData.append('id', item.id);
    formData.append('quantity', item.quantity);

    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        formData.append('properties[' + key + ']', item.properties[key]);
      });
    }

    if (cartController && typeof cartController.getSectionsToRender === 'function') {
      var sections = cartController.getSectionsToRender();
      for (var i = 0; i < sections.length; i++) {
        formData.append('sections', sections[i].id);
      }
      formData.append('sections_url', window.location.pathname);
    }

    if (cartController && typeof cartController.setActiveElement === 'function') {
      cartController.setActiveElement(document.activeElement);
    }

    config.body = formData;

    var cartAddUrl =
      typeof routes !== 'undefined' && routes.cart_add_url
        ? routes.cart_add_url
        : '/cart/add.js';

    return fetch(cartAddUrl, config).then(function (response) {
      return response.text().then(function (text) {
        var data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          throw new Error("Réponse non JSON reçue lors de l'ajout panier.");
        }

        if (!response.ok || (data && data.status)) {
          throw new Error(data.description || data.message || "Erreur lors de l'ajout au panier");
        }

        if (cartController && typeof cartController.renderContents === 'function') {
          cartController.renderContents(data);
        }

        return data;
      });
    });
  }

  function refreshCartUI() {
    var rootUrl = state.shopRootUrl || '/';

    return Promise.all([
      fetch(rootUrl + '?sections=cart-drawer,cart-icon-bubble', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Impossible de recharger les sections panier');
        }
        return response.json();
      }),

      fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Impossible de lire le panier');
        }
        return response.json();
      })
    ])
      .then(function (results) {
        var sections = results[0];
        var cart = results[1];

        replaceSectionOuterHTML('CartDrawer', sections['cart-drawer']);
        replaceSectionOuterHTML('cart-drawer', sections['cart-drawer']);

        replaceCartBubbleHTML(sections['cart-icon-bubble'], cart.item_count || 0);

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.classList !== 'undefined') {
          if ((cart.item_count || 0) > 0) {
            cartDrawer.classList.remove('is-empty');
          } else {
            cartDrawer.classList.add('is-empty');
          }
        }
      })
      .catch(function (error) {
        console.error('Erreur refresh panier', error);
      });
  }

  function replaceCartBubbleHTML(html, count) {
    if (!html) return;

    var parser = new DOMParser();
    var parsed = parser.parseFromString(html, 'text/html');

    var newBubble = parsed.getElementById('cart-icon-bubble');
    var currentBubble = document.getElementById('cart-icon-bubble');

    if (newBubble && currentBubble) {
      currentBubble.outerHTML = newBubble.outerHTML;
    }

    syncCartBubbleAccessibility(count);
  }

  function replaceSectionOuterHTML(containerId, html) {
    if (!html) return;

    var parser = new DOMParser();
    var parsed = parser.parseFromString(html, 'text/html');

    var newNode = parsed.getElementById(containerId);
    var currentNode = document.getElementById(containerId);

    if (newNode && currentNode) {
      currentNode.outerHTML = newNode.outerHTML;
    }
  }

  function syncCartBubbleAccessibility(count) {
    var wrappers = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble');

    for (var i = 0; i < wrappers.length; i++) {
      if (count <= 0) {
        wrappers[i].classList.add('hidden');
      } else {
        wrappers[i].classList.remove('hidden');
      }
    }

    var texts = document.querySelectorAll('#cart-icon-bubble .visually-hidden');
    for (var j = 0; j < texts.length; j++) {
      texts[j].textContent = count + ' articles';
    }
  }

  function buildSelectedCardsText(selectedCards) {
    if (!selectedCards || !selectedCards.length) return '';
    var lines = [];

    for (var i = 0; i < selectedCards.length; i++) {
      lines.push(selectedCards[i].name + ' x' + selectedCards[i].quantity);
    }

    return lines.join(' | ');
  }

  function buildCreationsText(creations) {
    if (!creations || !creations.length) return '';
    var lines = [];

    for (var i = 0; i < creations.length; i++) {
      lines.push('Création ' + (i + 1) + ' : ' + creations[i].text);
    }

    return lines.join(' | ');
  }

  function showCartFeedback() {
    var summary = document.getElementById('cs-sticky-summary');
    if (!summary) {
      window.location.href = '/cart';
      return;
    }

    var existing = document.getElementById('cs-cart-feedback');
    if (existing) existing.remove();

    var box = document.createElement('div');
    box.id = 'cs-cart-feedback';
    box.className = 'cs-cart-feedback';
    box.innerHTML =
      '<div class="cs-cart-feedback__text">Votre sélection a bien été ajoutée au panier.</div>' +
      '<div class="cs-cart-feedback__actions">' +
      '<a href="/collections/all" class="cs-cart-feedback__link">Continuer mes achats</a>' +
      '<a href="/cart" class="cs-cart-feedback__button">Voir mon panier</a>' +
      '</div>';

    summary.insertAdjacentElement('afterend', box);
  }

  function normalizeKey(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCardsByCategory(slug) {
    var result = [];
    var target = normalizeKey(slug);

    for (var i = 0; i < state.cards.length; i++) {
      var card = state.cards[i];
      if (!Array.isArray(card.categories)) continue;

      for (var j = 0; j < card.categories.length; j++) {
        if (normalizeKey(card.categories[j]) === target) {
          result.push(card);
          break;
        }
      }
    }

    return result;
  }

  function getSelectedCountByCategory(slug) {
    var total = 0;
    var target = normalizeKey(slug);

    for (var i = 0; i < state.cards.length; i++) {
      var card = state.cards[i];
      if (!Array.isArray(card.categories)) continue;

      var belongsToCategory = false;
      for (var j = 0; j < card.categories.length; j++) {
        if (normalizeKey(card.categories[j]) === target) {
          belongsToCategory = true;
          break;
        }
      }

      if (belongsToCategory) {
        total += Number(state.quantities[card.code] || 0);
      }
    }

    return total;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(Number(cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
});